/*
 * @Description:
 * @version:
 * @Date: 2023-07-14 16:58:46
 * @LastEditTime: 2024-05-22 13:42:00
 */

import Layout from '@/layout/layout.vue';
import localStorageKeyConst from '@/constants/local-storage-key-const';
const { LOGIN_PAGE, HOME_PAGE } = localStorageKeyConst;

const login = {
  path: '/login',
  name: LOGIN_PAGE,
  meta: {
    title: '登录',
    hideMenuFlag: true
  },
  component: () => import('@/views/login.vue')
};

const home = {
  path: '/',
  name: '_home',
  redirect: {
    name: HOME_PAGE
  },
  meta: {
    title: '首页',
    hideMenuFlag: true
  },
  component: Layout,
  children: [
    {
      path: '/home',
      name: HOME_PAGE,
      meta: {
        title: '首页',
        hideMenuFlag: true
      },
      component: () => import('@/views/home.vue')
    }
  ]
};

export const staticRoutes = [login, home];
